import React, { Fragment } from 'react';
import { Col, Form, InputGroup } from 'react-bootstrap';
import CrudSimpleForm from '../../../components/Systema/Crud/CrudSimpleForm';
import HierarchicalParentSelect from './HierarchicalParentSelect';
import schema from './schema';
import service from './service';

export default function EstruturaOrganizacionalForm({ match, returnUrl }) {
  const updateId = match && match.params && match.params.updateId;

  return (
    <CrudSimpleForm
      updateId={updateId}
      validationSchema={schema}
      service={service}
      returnUrl={returnUrl}
    >
      {({ handleChange, values, errors }) => (
        <Fragment>
          <Form.Row>
            <Form.Group as={Col} xs={6} lg={6}>
              <Form.Label>Estrutura Operacional</Form.Label>
              <HierarchicalParentSelect
                id='estruturaOrganizacionalPai'
                name='estruturaOrganizacionalPai'
                value={values.estruturaOrganizacionalPai}
                onChange={handleChange}
                isInvalid={!!errors.estruturaOrganizacionalPai}
              />
              <Form.Control.Feedback type='invalid'>
                {errors.estruturaOrganizacionalPai}
              </Form.Control.Feedback>
            </Form.Group>
          </Form.Row>

          <Form.Row>
            <Form.Group as={Col} xs={12} md={4}>
              <Form.Label>Código</Form.Label>
              <InputGroup size='sm'>
                <InputGroup.Prepend>
                  <InputGroup.Text size='sm'>
                    {values.estruturaOrganizacionalPai &&
                      values.estruturaOrganizacionalPai.codigoCompleto}
                    {values.estruturaOrganizacionalPai ? '.' : null}{' '}
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  id='codigo'
                  placeholder='Complemente o Código'
                  size='sm'
                  value={values.codigo}
                  onChange={handleChange}
                  isInvalid={!!errors.codigo}
                />
                <Form.Control.Feedback type='invalid'>
                  {errors.codigo}
                </Form.Control.Feedback>
              </InputGroup>
            </Form.Group>

            <Form.Group as={Col} xs={12} md={6}>
              <Form.Label>Nome</Form.Label>
              <Form.Control
                id='nome'
                placeholder='Nome'
                size='sm'
                value={values.nome}
                onChange={handleChange}
                isInvalid={errors.nome}
              />
              <Form.Control.Feedback type='invalid'>
                {errors.nome}
              </Form.Control.Feedback>
            </Form.Group>
          </Form.Row>
        </Fragment>
      )}
    </CrudSimpleForm>
  );
}
